var swiper = new Swiper('.swiper-container', {
  slidesPerView: 3, // Show 3 slides per view
  spaceBetween: 15, // Reduce space between slides
  navigation: {
    nextEl: '.btn1',
    prevEl: '.btn2',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    // Show 1 slide on small screens
    768: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    // Show 2 slides on medium screens
    1024: {
      slidesPerView: 3,
      spaceBetween: 15
    },
    // Show 3 slides on desktop screens
    1200: {
      slidesPerView: 3,
      spaceBetween: 15 // Adjust space to fit 3 slides properly
    }
  }
});


var swiper = new Swiper('.swiper-containerrr', {
  slidesPerView: 3, // Show 3 slides per view
  spaceBetween: 15, // Reduce space between slides
  navigation: {
    nextEl: '.btn3',
    prevEl: '.btn4',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    // Show 1 slide on small screens
    768: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    // Show 2 slides on medium screens
    1024: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    // Show 3 slides on desktop screens
    1200: {
      slidesPerView: 3,
      spaceBetween: 15 // Adjust space to fit 3 slides properly
    }
  }
});
